import React from 'react';
import { Grid } from '@quillbot/design-system';

import { makeStyles } from '@mui/styles';

const useStyles = makeStyles((theme) => ({
  termsMainContainers: {
    maxWidth: '1000px',
    margin: 'auto',
    paddingBottom: '25px',
  },
}));
function TermsPageDE() {
  const classes = useStyles();
  /*   useEffect(() => {
    Track.visitedPage('terms');
  }); */

  return (
    <div className="container">
      <div className={`${classes.termsMainContainers} terms-main-container`}>
        <Grid container justifyContent="center">
          <Grid item xs={12}>
            <h1 className="pageTitle">Nutzungsbedingungen</h1>
          </Grid>
        </Grid>
        <div className="terms-total-container qbp-pt20" style={{ textAlign: 'justify' }}>
          <p>
            BITTE LESEN SIE ALLE FOLGENDEN BESTIMMUNGEN SORGFÄLTIG DURCH, DA SIE INFORMATIONEN ÜBER
            IHRE GESETZLICHEN RECHTE, RECHTSMITTEL UND VERPFLICHTUNGEN ENTHALTEN. DIESE VEREINBARUNG
            ENTHÄLT IN ABSCHNITT 14 EINE OBLIGATORISCHE SCHIEDSGERICHTSKLAUSEL, DIE VORSCHREIBT,
            DASS STREITIGKEITEN DURCH EIN SCHIEDSGERICHT AUF INDIVIDUELLER BASIS UND NICHT DURCH
            SCHWURGERICHTSVERFAHREN ODER SAMMELKLAGEN BEIGELEGT WERDEN. WENN SIE EIN QUILLBOT-
            ABONNENT WERDEN UND PER KREDIT- ODER DEBITKARTE BEZAHLEN (ODER MIT EINER ANDEREN
            ZAHLUNGSMETHODE, DIE MIT EINEM SICH AUTOMATISCH VERLÄNGERNDEN ABONNEMENT VERBUNDEN IST),
            VERLÄNGERT SICH IHR ABONNEMENT AUTOMATISCH UM BESTIMMTE ZEITRÄUME, WENN SIE NICHT
            BESTIMMTE SCHRITTE UNTERNEHMEN. WEITERE INFORMATIONEN ZU DEN BEDINGUNGEN FÜR DIE
            AUTOMATISCHE VERLÄNGERUNG VON ABONNEMENTS FINDEN SIE IN ABSCHNITT 4.
          </p>
          <p>Gültig ab 1. März 2022</p>
          <p>
            Diese Dienstleistungsvereinbarung („Vereinbarung“) wird zwischen QuillBot (Course Hero),
            LLC („QuillBot“), dem Betreiber von QuillBot.com und der damit verfügbaren
            Programmierschnittstelle (die „API“) (zusammen die „Plattform“) und Ihnen („Nutzer“)
            geschlossen, der nur gemäß den folgenden Bedingungen auf die Plattform und die darauf
            befindliche Technologie zugreifen und sie nutzen darf.
          </p>
          <ol>
            <li>
              <p>
                <b>Akzeptanz der Bedingungen.</b>
                <br />
                Durch den Zugriff auf und die Nutzung der Plattform LESEN, VERSTEHEN, AKZEPTIEREN
                und VERPFLICHTEN sich die Nutzer, an die Bedingungen dieser Vereinbarung gebunden zu
                sein. Sollte der Nutzer diese Bedingungen NICHT akzeptieren, darf er weder auf die
                Plattform noch auf die dort verfügbaren Inhalte oder Informationen zugreifen oder
                sie anderweitig nutzen. Soweit gesetzlich zulässig, kann QuillBot diese Vereinbarung
                jederzeit und von Zeit zu Zeit ändern, indem es eine Version dieser Vereinbarung auf{' '}
                <a href="https://quillbot.com/terms"> https://quillbot.com/terms</a> veröffentlicht.
                QuillBot wird den Nutzer auf seiner Website und/oder per E-Mail über die
                Veröffentlichung der geänderten Bedingungen informieren. Der Nutzer erklärt sich
                damit einverstanden, dass seine fortgesetzte Nutzung der Plattform eine Akzeptanz
                solcher Änderungen darstellt. Der Nutzer hat die Möglichkeit, diese Änderungen
                abzulehnen, indem er den Zugang zur Plattform und deren Nutzung einstellt.
              </p>
            </li>

            <li>
              <p>
                <b> Wohnsitz und Alter.</b>
                <br />
                Die Plattform ist für den Zugriff und die Nutzung durch Nutzer bestimmt, die in
                ihrem jeweiligen Staat oder ihrer jeweiligen Provinz die Volljährigkeit erreicht
                haben. Durch den Zugriff auf die Plattform und deren Nutzung sichert der Nutzer
                hiermit zu, dass er entweder mindestens 18 Jahre alt ist, volljährig ist oder die
                Zustimmung eines Elternteils oder Erziehungsberechtigten eingeholt hat. Der Nutzer
                versichert hiermit, dass er mindestens und ohne Ausnahme 13 Jahre alt ist. Die
                Plattform ist nicht für den Zugriff oder die Nutzung durch Kinder unter 13 Jahren
                bestimmt.
              </p>
            </li>

            <li>
              <p>
                <b>
                  <u> Ausschluss von Garantien.</u>
                </b>
                <br />
                <b>
                  <u>
                    DIE PLATTFORM UND IHR GESAMTER INHALT SOWIE DIE INFORMATIONEN UND MATERIALIEN,
                    DIE DAMIT ZUR VERFÜGUNG GESTELLT WERDEN, WERDEN OHNE MÄNGELGEWÄHR ZUR VERFÜGUNG
                    GESTELLT, UND QUILLBOT LEHNT HIERMIT ALLE AUSDRÜCKLICHEN UND STILLSCHWEIGENDEN
                    GARANTIEN AB, EINSCHLIESSLICH, ABER NICHT BESCHRÄNKT AUF GARANTIEN DER
                    MARKTGÄNGIGKEIT, DER NICHTVERLETZUNG VON RECHTEN UND DER EIGNUNG FÜR EINEN
                    BESTIMMTEN ZWECK. SOWEIT GESETZLICH ZULÄSSIG, LEHNT QUILLBOT AUSDRÜCKLICH JEDE
                    ZUSICHERUNG AB, DASS: (I) DIE PLATTFORM DEN ANFORDERUNGEN DES NUTZERS
                    ENTSPRICHT; (II) DER ZUGANG ZUR PLATTFORM UNUNTERBROCHEN, RECHTZEITIG, SICHER
                    ODER FEHLERFREI IST; (III) JEGLICHE INFORMATIONEN, DIE ÜBER ODER VON DER
                    PLATTFORM ERHALTEN WERDEN, GENAU ODER ZUVERLÄSSIG SIND; (IV) DIE QUALITÄT
                    JEGLICHER PRODUKTE, DIENSTLEISTUNGEN, INFORMATIONEN ODER ANDERER MATERIALIEN,
                    DIE DER NUTZER ÜBER DIE PLATTFORM GEKAUFT ODER ERHALTEN HAT, DEN ERWARTUNGEN
                    ENTSPRICHT; (V) JEGLICHE VOM NUTZER BEREITGESTELLTEN INFORMATIONEN NICHT AN
                    DRITTE WEITERGEGEBEN WERDEN; ODER (VI) JEGLICHE DATEN- ODER SOFTWAREFEHLER
                    KORRIGIERT WERDEN.
                  </u>
                </b>
              </p>
            </li>

            <li>
              <b>Verwendungen der Plattform.</b>
              <ol type="a">
                <li>
                  <p>
                    <b>QuillBot™-Nutzung im Allgemeinen</b>.
                    <br />
                    Die Plattform ermöglicht es dem Nutzer im Allgemeinen, gemäß den hierin
                    festgelegten Bedingungen, Textinhalte, die der Nutzer an die Plattform sendet
                    („Beiträge“), unter Verwendung der plattformeigenen QuillBot™
                    Thesaurustechnologie zu vergleichen und neu zu formulieren und daraus Metriken
                    zu erhalten. Der Nutzer kann die QuillBot™-Konfiguration(en) anpassen, um
                    Variationen des umformulierten Textinhalts (der „Output“) zu erhalten, und kann
                    den Output für die Zwecke des Nutzers bearbeiten.
                  </p>
                </li>

                <li>
                  <p>
                    <b>Registrierung. </b>
                    <br />
                    Um bestimmte Funktionen der Plattform nutzen zu können, wird der Nutzer
                    möglicherweise aufgefordert, sich auf der Plattform zu registrieren. Der Nutzer
                    erklärt sich damit einverstanden: (i) wahrheitsgemäße, genaue, aktuelle und
                    vollständige Angaben („Nutzerinformationen“) über sich selbst zu machen, wie sie
                    in einem Registrierungsformular abgefragt werden; und (ii) seine
                    Nutzerinformationen aufrechtzuerhalten und unverzüglich zu aktualisieren, damit
                    sie wahrheitsgemäß, genau, aktuell und vollständig bleiben. Wenn QuillBot den
                    begründeten Verdacht hat, dass die Nutzerinformationen unwahr, ungenau, nicht
                    aktuell oder unvollständig sind, kann QuillBot den Zugang des Nutzers zur und
                    die Nutzung der Plattform (oder eines Teils davon) aussetzen oder kündigen. Der
                    Nutzer ist allein und in vollem Umfang für die Wahrung der Vertraulichkeit
                    seines Nutzernamens, seines Passworts und, falls zutreffend, seines
                    API-Schlüssels („Berechtigungsnachweise“) verantwortlich und ist allein und in
                    vollem Umfang für alle Aktivitäten verantwortlich, die unter seinen
                    Berechtigungsnachweisen stattfinden. Der Nutzer verpflichtet sich: (i) QuillBot
                    unverzüglich über jede unbefugte Nutzung der Zugangsdaten des Nutzers oder jede
                    andere Verletzung der Sicherheit zu informieren; und (ii) sicherzustellen, dass
                    sich der Nutzer am Ende jeder Webanwendungssitzung von seinem Konto abmeldet.
                    QuillBot kann und wird nicht für Verluste oder Schäden haften, die aus der
                    Nichteinhaltung dieses Abschnitts durch den Nutzer entstehen.
                  </p>
                </li>

                <li>
                  <p>
                    <b>Bezahlte Dienste.</b>
                  </p>
                  <ol type="i">
                    <li>
                      <p>
                        <b>Allgemeines.</b>
                        <br />
                        Wenn der Nutzer Dienstleistungen erwirbt, die QuillBot gegen eine Gebühr
                        anbietet („Bezahlte Dienstleistungen“), wie z. B. ein Abonnement für die
                        Dienstleistungen von QuillBot, ermächtigt der Nutzer QuillBot und seine
                        designierten Zahlungsabwickler, die Zahlungsinformationen des Nutzers und
                        andere damit verbundene Informationen zu speichern. Der Nutzer stimmt
                        außerdem zu, die anwendbaren Gebühren für die bezahlten Dienstleistungen
                        (einschließlich, aber nicht beschränkt auf regelmäßige Gebühren für laufende
                        Abonnements (die „Abonnementgebühren“)) zu zahlen, wenn sie fällig werden,
                        zuzüglich aller damit verbundenen Steuern (einschließlich, aber nicht
                        beschränkt auf Umsatz- und Nutzungssteuern, Zölle oder andere staatliche
                        Steuern oder Gebühren), und QuillBot alle Inkassokosten und Zinsen für
                        überfällige Beträge zu erstatten. Alle Gebühren und Entgelte sind nicht
                        erstattungsfähig und es gibt keine Rückerstattungen oder Gutschriften für
                        teilweise genutzte kostenpflichtige Dienstleistungen (einschließlich
                        teilweise genutzter Abonnementzeiträume), außer: (i) wie durch geltendes
                        Recht vorgeschrieben; und (iii) nach alleinigem und absolutem Ermessen von
                        QuillBot. Die Gebühren für die kostenpflichtigen Dienste können im Voraus,
                        nachträglich, pro Nutzung oder wie anderweitig beschrieben, wenn Sie die
                        kostenpflichtigen Dienste erwerben, bezahlt werden. Sofern in diesem
                        Abschnitt 4 nicht anders beschrieben, können alle Preise für
                        kostenpflichtige Dienste ohne vorherige Ankündigung geändert werden.
                      </p>
                    </li>
                    <li>
                      <p>
                        <b>Plagiatsprüfung</b>
                        <br />
                        QuillBot nutzt einen Drittanbieter, um die Plagiatsprüfung als Teil des
                        kostenpflichtigen Dienstes anzubieten. Wenn Sie den kostenpflichtigen
                        Service abonnieren, können Sie den Plagiatsprüfer auf bis zu 20 Seiten
                        (maximal 250 Wörter pro Seite) pro Monat während Ihres Abonnementzeitraums
                        verwenden. Für die Zwecke dieses Absatzes wird die Verwendung des
                        Plagiatsprüfers auf einer Seite als „Scan“ bezeichnet. Werden in einem Monat
                        keine 20 Scans durchgeführt, wird das Abonnement nicht verlängert. Nutzer
                        haben die Möglichkeit, zusätzliche Scans pro Monat gegen eine einmalige
                        Zahlung an QuillBot zu erwerben. Zusätzliche Scans, die in einem bestimmten
                        Monat gekauft, aber nicht verwendet werden, werden bis zur Verwendung
                        fortgesetzt.
                      </p>
                    </li>

                    <li>
                      <p>
                        <b>Zahlungsmethode.</b>
                        <br />
                        QuillBot kann von Zeit zu Zeit verschiedene Zahlungsmethoden anbieten,
                        einschließlich und ohne Einschränkung die Zahlung per Kreditkarte, per
                        Debitkarte, per Scheck, durch bestimmte Zahlungsanbieter. Der Nutzer
                        ermächtigt QuillBot, dem Nutzer die bezahlten Dienstleistungen über die vom
                        Nutzer beim Kauf der bezahlten Dienstleistungen ausgewählte(n)
                        Zahlungsmethode(n) (die „Zahlungsmethode“) in Rechnung zu stellen, und der
                        Nutzer erklärt sich damit einverstanden, die Zahlung über diese
                        Zahlungsmethode(n) vorzunehmen (QuillBot kann von Zeit zu Zeit aktualisierte
                        Informationen über die Zahlungsmethode(n) erhalten und verwenden, die vom
                        Nutzer zur Verfügung gestellt werden oder die von Finanzinstituten oder
                        Zahlungsdienstleistern an QuillBot übermittelt werden, um die Informationen
                        über die Zahlungsmethode(n) des Nutzers zu aktualisieren, wie z. B.
                        aktualisierte Ablaufdaten oder Kontonummern). Bestimmte Zahlungsmethoden,
                        wie z. B. Kreditkarten und Debitkarten, können Vereinbarungen zwischen dem
                        Nutzer und dem Finanzinstitut, dem Kreditkartenaussteller oder einem anderen
                        Anbieter der vom Nutzer gewählten Zahlungsmethode (der „Anbieter der
                        Zahlungsmethode“) beinhalten. Wenn QuillBot keine Zahlung vom Anbieter der
                        Zahlungsmethode des Nutzers erhält, erklärt sich der Nutzer bereit, alle
                        fälligen Beträge auf Anfrage von QuillBot direkt zu bezahlen. Die
                        Nicht-Kündigung oder fortgesetzte Nutzung der bezahlten Dienstleistungen
                        durch den Nutzer bestätigt, dass QuillBot berechtigt ist, die
                        Zahlungsmethode des Nutzers zu belasten.
                      </p>
                    </li>

                    <li>
                      <p>
                        <b>Automatische Erneuerung von Abonnements.</b>
                        <br />
                        WENN DER NUTZER EIN ABONNEMENT PER KREDIT- ODER DEBITKARTE BEZAHLT (ODER
                        EINE ANDERE ZAHLUNGSMETHODE, DIE AUF QUILLBOTS DIENSTEN ODER EINER SOZIALEN
                        NETZWERKSEITE ALS AUTOMATISCH VERLÄNGERNDES ABONNEMENT GEKENNZEICHNET IST)
                        UND DER NUTZER DAS ABONNEMENT NICHT WIE IN DIESEM ABSCHNITT 4 BESCHRIEBEN
                        KÜNDIGT, VERLÄNGERT SICH DAS ABONNEMENT DES NUTZERS AUTOMATISCH UM
                        AUFEINANDERFOLGENDE VERLÄNGERUNGSPERIODEN MIT DER GLEICHEN DAUER WIE DIE
                        URSPRÜNGLICH GEWÄHLTE ABONNEMENTDAUER (ZUM BEISPIEL WIRD EIN EINMONATIGES
                        ABONNEMENT AUTOMATISCH MONATLICH VERLÄNGERT, WENN DER NUTZER NICHT KÜNDIGT).
                        SOFERN NICHT IN DEN ZUSÄTZLICHEN BEDINGUNGEN ODER IN DEN MITTEILUNGEN, DIE
                        QUILLBOT AN DIE REGISTRIERTE E-MAIL-ADRESSE DES NUTZERS SENDET, ETWAS
                        ANDERES ANGEGEBEN IST, GILT FÜR EINE SOLCHE VERLÄNGERUNG DIE GLEICHE
                        ABONNEMENTGEBÜHR WIE BEI DER ERSTEN ANMELDUNG DES NUTZERS, ZUZÜGLICH ALLER
                        ANFALLENDEN STEUERN, ES SEI DENN, QUILLBOT BENACHRICHTIGT DEN NUTZER
                        MINDESTENS 10 TAGE VOR DEM ENDE DER AKTUELLEN LAUFZEIT, DASS DIE
                        ABONNEMENTGEBÜHR ERHÖHT WIRD. DER NUTZER ERKENNT AN UND STIMMT ZU, DASS DIE
                        ZAHLUNGSMETHODE DES NUTZERS BEI JEDER AUTOMATISCHEN VERLÄNGERUNG AUTOMATISCH
                        MIT DEN ABONNEMENTGEBÜHREN, ZUZÜGLICH ALLER ANFALLENDEN STEUERN, BELASTET
                        WIRD. DER NUTZER ERKENNT AN, DASS DAS ABONNEMENT DES NUTZERS AUTOMATISCHEN
                        VERLÄNGERUNGEN UNTERLIEGT, UND DER NUTZER STIMMT ZU UND ÜBERNIMMT DIE
                        VERANTWORTUNG FÜR ALLE WIEDERKEHRENDEN ABBUCHUNGEN VON DER KREDIT- ODER
                        DEBITKARTE DES NUTZERS (ODER EINER ANDEREN ZAHLUNGSMETHODE, FALLS
                        ZUTREFFEND), DIE AUF DIESER AUTOMATISCHEN VERLÄNGERUNGSFUNKTION BASIEREN,
                        OHNE WEITERE AUTORISIERUNG DES NUTZERS UND OHNE WEITERE BENACHRICHTIGUNG,
                        SOFERN NICHT GESETZLICH VORGESCHRIEBEN. DER NUTZER ERKENNT FERNER AN, DASS
                        SICH DER BETRAG DER WIEDERKEHRENDEN GEBÜHREN ÄNDERN KANN, WENN SICH DIE
                        GELTENDEN STEUERSÄTZE ÄNDERN, ODER, WENN DER NUTZER ÜBER EINE ERHÖHUNG DER
                        GELTENDEN ABONNEMENTGEBÜHREN INFORMIERT WIRD.
                      </p>
                    </li>

                    <li>
                      <p>
                        <b>Kündigung des Abonnements.</b>
                        <br />
                        UM DAS ABONNEMENT DES NUTZERS JEDERZEIT ZU ÄNDERN ODER ZU KÜNDIGEN, KANN DER
                        NUTZER NACH DER ANMELDUNG AUF DER PLATTFORM DIE SEITE
                        &quot;KONTOEINSTELLUNGEN&quot; AUFRUFEN UND SICH FÜR &quot;ABMELDEN&quot;
                        ENTSCHEIDEN. WENN DER NUTZER SEIN ABONNEMENT KÜNDIGT, BLEIBEN DIE VORTEILE
                        DES ABONNEMENTS DES NUTZERS BIS ZUM ENDE DER AKTUELLEN ABONNEMENTDAUER
                        BESTEHEN, ABER DAS ABONNEMENT DES NUTZERS WIRD NACH ABLAUF DIESER DAUER
                        NICHT VERLÄNGERT. DER NUTZER HAT KEINEN ANSPRUCH AUF EINE ANTEILIGE
                        RÜCKERSTATTUNG DER FÜR DIE AKTUELLE ABONNEMENTLAUFZEIT GEZAHLTEN
                        ABONNEMENTGEBÜHREN, ES SEI DENN, DIES IST DURCH GELTENDES RECHT
                        VORGESCHRIEBEN.
                      </p>
                    </li>

                    <li>
                      <p>
                        <b>Aktuelle Rechnungsinformationen erforderlich.</b>
                        <br />
                        Der Nutzer erklärt sich damit einverstanden, aktuelle, vollständige und
                        korrekte Rechnungsinformationen anzugeben und alle diese Informationen (wie
                        z. B. Änderungen der Rechnungsadresse, der Kreditkartennummer oder des
                        Ablaufdatums der Kreditkarte) umgehend zu aktualisieren, soweit dies für die
                        Bearbeitung aller an QuillBot zu leistenden Zahlungen erforderlich ist. Der
                        Nutzer erklärt sich damit einverstanden, QuillBot unverzüglich zu
                        benachrichtigen, wenn die Zahlungsmethode des Nutzers gekündigt wird (z. B.
                        aufgrund von Verlust oder Diebstahl) oder wenn der Nutzer von einer
                        möglichen Verletzung der Sicherheit im Zusammenhang mit der Zahlungsmethode
                        des Nutzers erfährt. Falls der Nutzer eine der vorgenannten Informationen
                        nicht zur Verfügung stellt, erkennt der Nutzer an, dass die aktuelle
                        Zahlungsmethode des Nutzers weiterhin für bezahlte Dienstleistungen in
                        Rechnung gestellt werden kann und dass der Nutzer für alle diese Gebühren
                        verantwortlich bleibt.
                      </p>
                    </li>

                    <li>
                      <p>
                        <b>Änderung des autorisierten Betrags.</b>
                        <br />
                        Wenn der zu berechnende Gesamtbetrag von dem Betrag abweicht, den der Nutzer
                        beim Kauf einer kostenpflichtigen Dienstleistung genehmigt hat (außer
                        aufgrund der Auferlegung oder Änderung der Höhe von Steuern, einschließlich
                        aber nicht beschränkt auf Umsatz- und Nutzungssteuern, Zölle oder andere
                        staatliche Steuern oder Gebühren), wird QuillBot den zu berechnenden Betrag
                        und das Datum der Belastung mindestens 10 Tage vor dem geplanten Datum der
                        Transaktion bekannt geben. Wenn der Nutzer seine kostenpflichtigen
                        Dienstleistungen nicht kündigt, bevor der erhöhte Preis in Kraft tritt,
                        stimmt der Nutzer zu, den erhöhten Preis für die kostenpflichtigen
                        Dienstleistungen zu zahlen. Der Nutzer erklärt sich damit einverstanden,
                        dass QuillBot die angefallenen Kosten akkumuliert und sie als eine oder
                        mehrere Gesamtkosten während oder am Ende eines jeden Abrechnungszyklus
                        einreicht. QuillBot wird den Nutzer über alle zusätzlichen Gebühren, die
                        kumuliert werden, informieren.
                      </p>
                    </li>

                    <li>
                      <p>
                        <b>Zahlungsabwickler.</b>
                        <br />
                        Die Bestellung von Dienstleistungen über die Plattform beinhaltet die
                        Nutzung des gesicherten Servers eines Zahlungsabwicklungsdienstleisters
                        („PSP“, z. B. Stripe). Weder PSP noch irgendeine Person oder Firma, die mit
                        PSP in Verbindung steht, hat ein Eigentumsrecht an der Plattform oder an
                        QuillBot, noch erhält sie irgendeinen finanziellen Vorteil von der Plattform
                        oder von QuillBot, außer einer Gebühr, die von QuillBot an PSP für die von
                        PSP erbrachten Dienstleistungen gezahlt wird. QuillBot macht keinerlei
                        Zusicherungen und/oder Garantien und gibt keine Zusicherungen in Bezug auf
                        die PSP, den PSP-Eigentümer oder die Qualität, Verfügbarkeit, Rechtmäßigkeit
                        oder Beschreibung der darauf angebotenen Zahlungsabwicklungsdienste.
                        QUILLBOT LEHNT AUSDRÜCKLICH JEGLICHE GEWÄHRLEISTUNG DER MARKTGÄNGIGKEIT, DER
                        NICHTVERLETZUNG VON RECHTEN ODER DER EIGNUNG FÜR EINEN BESTIMMTEN ZWECK IN
                        BEZUG AUF DIE PSP UND/ODER DIE DARAUF ANGEBOTENEN DIENSTLEISTUNGEN AB.
                      </p>
                    </li>
                  </ol>
                </li>

                <li>
                  <p>
                    <b>API-Verwendung.</b>
                  </p>
                  <ol type="i">
                    <li>
                      <p>
                        QuillBot kann nach eigenem Ermessen Grenzen für die API-Nutzung des Nutzers
                        festlegen, einschließlich, aber nicht beschränkt auf die Häufigkeit, mit der
                        die Anfragen des Nutzers verarbeitet werden. QuillBot kann solche
                        Nutzungsbeschränkungen jederzeit ändern und/oder technische Maßnahmen
                        ergreifen, um eine übermäßige Nutzung zu verhindern und/oder die Nutzung der
                        APIs durch eine Anwendung zu stoppen, nachdem die Nutzungsbeschränkungen
                        überschritten wurden.
                      </p>
                    </li>

                    <li>
                      <p>
                        Der Begriff „Markenmerkmale“ bezieht sich auf QuillBots Handelsnamen,
                        Warenzeichen, Dienstleistungsmarken, Logos (z. B. das QuillBot Roboterlogo),
                        Domainnamen und andere unverwechselbare Markenmerkmale. Der Nutzer stimmt
                        zu, die Wortmarke QUILLBOT von QuillBot, wenn überhaupt, nur sachlich und in
                        Verbindung mit der Implementierung der API in der Anwendung oder dem Produkt
                        des Nutzers zu verwenden. Der Nutzer darf kein anderes Markenmerkmal in
                        irgendeiner anderen Weise verwenden. Der Nutzer darf kein Markenmerkmal
                        modifizieren oder verändern oder auf eine verwirrende Art und Weise
                        verwenden, einschließlich der Andeutung von Sponsoring oder Befürwortung
                        durch QuillBot, oder auf eine Art und Weise, die QuillBot mit einer anderen
                        Marke verwechselt.
                      </p>
                    </li>
                  </ol>
                </li>
              </ol>
            </li>

            <li>
              <p>
                <b> Eigentumsrechte. </b>
                <br />
                Alle Rechte und Genehmigungen, die hier nicht ausdrücklich gewährt werden, sind
                QuillBot vorbehalten.
              </p>
              <ol type="a">
                <li>
                  <p>
                    Für die Dauer dieses Vertrages und sofern von QuillBot nicht anderweitig
                    schriftlich vereinbart, gewährt QuillBot dem Nutzer ein beschränktes,
                    widerrufliches, nicht ausschließliches, nicht übertragbares, nicht abtretbares,
                    nicht unterlizenzierbares Recht und eine Lizenz zur Nutzung der Plattform und
                    jeglicher API-Richtlinien für persönliche und nicht kommerzielle Zwecke des
                    Nutzers, vorausgesetzt, der Nutzer hält sich an alle Bedingungen dieses
                    Vertrages. Das Vorstehende ist eine ausdrückliche eingeschränkte Nutzungslizenz
                    und keine Abtretung, kein Verkauf oder eine andere Übertragung der Plattform
                    oder von Patenten, Urheberrechten, Geschäftsgeheimnissen, moralischen Rechten,
                    Marken, Know-how oder anderen verwandten oder anderen Rechten oder Interessen
                    oder anderen immateriellen Vermögenswerten, die unter Gesetzen, Vorschriften
                    oder internationalen Konventionen in einem beliebigen Land oder einer beliebigen
                    Gerichtsbarkeit auf der Welt anerkannt sind (zusammenfassend “geistige
                    Eigentumsrechte“) von QuillBot oder seinen Lizenzgebern. Vorbehaltlich der
                    Verbote in Abschnitt 6 sind alle Rechte, die nicht ausdrücklich gemäß diesem
                    Abschnitt lizenziert sind, vorbehalten, und bei Beendigung dieser Vereinbarung
                    erlöschen alle lizenzierten Rechte.
                  </p>
                </li>

                <li>
                  <p>
                    Der Nutzer gewährt QuillBot hiermit ein unbegrenztes, unwiderrufliches,
                    nicht-exklusives, übertragbares, abtretbares und unterlizenzierbares Recht und
                    eine Lizenz zur Nutzung der Einsendungen für jeden Zweck, einschließlich, aber
                    nicht beschränkt auf die Entwicklung der QuillBot™-Technologie, die
                    Bereitstellung von maßgeschneiderten Plattformerfahrungen für den Nutzer und die
                    Erzeugung des Outputs. Die nicht-exklusive Lizenz, die QuillBot hiermit gemäß
                    diesem Abschnitt gewährt wird, erstreckt sich auf alle damit verbundenen Rechte
                    an geistigem Eigentum an den Einsendungen und bleibt ungeachtet der Beendigung
                    dieser Vereinbarung auf Dauer bestehen.
                  </p>
                </li>

                <li>
                  <p>
                    Im größtmöglichen gesetzlich zulässigen Umfang ist QuillBot Eigentümer aller
                    Rechte, Titel und Anteile am Output, einschließlich, aber nicht beschränkt auf
                    alle darin enthaltenen Rechte an geistigem Eigentum. QuillBot gewährt dem Nutzer
                    hiermit ein beschränktes, widerrufliches, nicht ausschließliches, übertragbares,
                    abtretbares und unterlizenzierbares Recht und eine Lizenz zur Nutzung des
                    Outputs und der darin enthaltenen Rechte an geistigem Eigentum für die eigenen
                    Zwecke des Nutzers.
                  </p>
                </li>
              </ol>
            </li>

            <li>
              <p>
                <b>Plattformverbote. </b>
                <br />
                Der Nutzer erklärt sich damit einverstanden, dass es NICHT erlaubt ist: (a) die
                Plattform oder Inhalte oder Informationen, die über die Plattform verfügbar sind,
                für unerlaubte Zwecke zu nutzen, einschließlich, aber nicht beschränkt auf die
                Überschreitung von Übermittlungsbeschränkungen und Handlungen, die über den Umfang
                der bezahlten Dienste hinausgehen; (b) die Plattform zu stören oder zu beschädigen,
                einschließlich, aber nicht beschränkt auf die Verwendung von Viren, Spyware,
                Malware, schädlichem Code, Flood-Pings, Denial-of-Service-Angriffen, Paket- oder
                IP-Spoofing, gefälschtem Routing oder Methoden, die in irgendeiner Weise die
                Navigationsstruktur oder Darstellung der Plattform reproduzieren oder umgehen; (c)
                die Plattform zu nutzen, um Informationen über andere Personen zu sammeln, zu
                speichern oder zu verbreiten; (d) die Plattform zu nutzen, um rechtsverletzendes,
                obszönes, bedrohliches, verleumderisches oder anderweitig ungesetzliches oder
                unerlaubtes Material zu versenden oder zu speichern, einschließlich Material, das
                für Kinder schädlich ist oder die Datenschutzrechte Dritter verletzt; (e) die
                Plattform zu nutzen, um sich als eine andere Person, ein anderes Unternehmen oder
                eine andere Einrichtung auszugeben; (f) Codes, Daten, Inhalte oder Informationen,
                die über die Plattform oder Softwarekomponenten, die auf der Plattform oder für die
                Plattform oder den Zugang zu ihr verwendet werden, verfügbar sind, zu ändern,
                unterzulizenzieren, abzutreten, zu verschenken, zu übertragen, zu übersetzen, zu
                verkaufen, weiterzuverkaufen, zurückzuentwickeln, zu entschlüsseln, zu dekompilieren
                oder anderweitig zu disassemblieren; (g) zu versuchen, sich unbefugten Zugang zur
                Plattform oder zu den damit verbundenen Systemen oder Netzwerken zu verschaffen; (h)
                Software oder Skripte Dritter zu verwenden, um Informationen von oder über die
                Plattform zu sammeln; (i) die Plattform oder Inhalte oder Informationen, die über
                die Plattform verfügbar sind, unter Verletzung von Ausfuhr- oder Einfuhrgesetzen
                und/oder -vorschriften oder -beschränkungen der Vereinigten Staaten von Amerika und
                ihrer Agenturen oder Behörden oder ohne alle erforderlichen Genehmigungen, Lizenzen
                oder Befreiungen zu verbreiten, weiterzuverteilen oder deren Übertragung zu
                gestatten; (j) die Plattform zu nutzen, um unaufgeforderte Nachrichten, Kettenbriefe
                oder unaufgeforderte kommerzielle E- Mails zu verbreiten, zu speichern oder zu
                übertragen; (k) die Plattform zu nutzen, um Dateien, Grafiken, Software oder
                sonstiges Material zu verbreiten, zu speichern oder zu übertragen, das tatsächlich,
                stillschweigend oder potenziell das Urheberrecht, das Markenrecht, das Patentrecht,
                das Geschäftsgeheimnis, den Handelsnamen oder ein sonstiges Recht an geistigem
                Eigentum einer natürlichen oder juristischen Person, einer Partnerschaft, einer
                Organisation, einer Vereinigung oder in sonstiger Weise verletzt; (l) die Plattform
                anzupassen, zu übersetzen oder davon abgeleitete Werke zu erstellen oder die
                Plattform in andere Software einzubinden; (m) die Plattform zu nutzen, um Spyware,
                Adware, Spam oder andere bösartige Programme oder Codes, gefälschte Waren, Artikel,
                die einem US-Embargo unterliegen, Hassmaterialien oder Materialien, die zu
                terroristischen oder gewalttätigen Handlungen aufrufen, Waren, die aus geschützten
                Tier-/Pflanzenarten hergestellt wurden, zurückgerufene Waren, Hacking-,
                Überwachungs-, Abhör- oder Entschlüsselungsgeräte, illegale Drogen und Utensilien,
                den unlizenzierten Verkauf von verschreibungspflichtigen Medikamenten und
                medizinischen Geräten, den Verkauf von Tabak oder Alkohol an Personen unter 21
                Jahren, Pornografie, Prostitution, Körperteile und Körperflüssigkeiten, gestohlene
                Produkte und Gegenstände, die für Diebstähle verwendet werden, Feuerwerkskörper,
                Sprengstoffe und gefährliche Materialien, staatliche Ausweise, polizeiliche
                Gegenstände, nicht lizenzierter Handel mit Aktien und Wertpapieren, Glücksspiele,
                professionelle Dienstleistungen, die durch staatliche Zulassungsregelungen geregelt
                sind, nicht übertragbare Gegenstände wie Flugtickets oder Eintrittskarten für
                Veranstaltungen, nicht verpackte Lebensmittel oder Waffen und Zubehör anzuzeigen
                oder zu fördern; (n) die Plattform zu nutzen, um (direkt oder indirekt) ein
                ähnliches Produkt, einen ähnlichen Dienst oder eine ähnliche Plattform zu erstellen,
                zu trainieren oder zu verbessern, einschließlich anderer maschineller
                Lernalgorithmen oder maschineller Übersetzungs- oder Umschreibungssysteme; (o)
                übersetzten Text oder andere Daten der Plattform zu verwenden oder zu speichern, um
                (direkt oder indirekt) einen Übersetzungsdienst, ein Produkt oder eine Plattform zu
                erstellen, zu trainieren oder zu verbessern, einschließlich anderer maschineller
                Lernalgorithmen oder maschineller Übersetzungs- oder Umschreibungssysteme; (p) mehr
                als 300.000 Zeichen des Outputs der Plattform oder des Inputs und Outputs der
                Plattform in vergleichender Weise anzuzeigen oder öffentlich zugänglich zu machen
                (z. B. nebeneinander), (q) sofern nicht anderweitig schriftlich zwischen QuillBot
                und dem Nutzer vereinbart, die Plattform zu nutzen, um Datensätze zur Verbesserung
                von Systemen zur Verarbeitung natürlicher Sprache zu erweitern; oder (r) Dritte bei
                der Durchführung der vorgenannten Maßnahmen zu unterstützen.
              </p>
            </li>

            <li>
              <p>
                <b>Sicherheit des Nutzersystems. </b>
                <br />
                Der Nutzer trägt die alleinige Verantwortung für die Sicherheit, Vertraulichkeit und
                Integrität aller Inhalte, die der Nutzer über die Plattform oder auf einem Computer,
                Mobilgerät oder einem damit verbundenen Gerät, das für den Zugriff auf die Plattform
                verwendet wird, erhält, überträgt oder speichert.
              </p>
            </li>

            <li>
              <p>
                <b>Laufzeit und Beendigung. </b>
                <br />
                Diese Vereinbarung bleibt von dem Moment an, in dem der Nutzer auf die Plattform
                zugreift oder sie nutzt, bis zu ihrer Beendigung in Kraft. Dieser Vertrag endet
                automatisch und ohne Benachrichtigung durch QuillBot, wenn der Nutzer eine
                Bestimmung dieses Vertrages nicht einhält. QuillBot behält sich das Recht vor, nach
                eigenem Ermessen und ohne vorherige Benachrichtigung des Nutzers, jederzeit und aus
                jedem Grund, um: (i) den Zugang zur Plattform ganz oder teilweise zu entfernen oder
                zu sperren; (ii) den Zugang des Nutzers zur Plattform ganz oder teilweise zu
                sperren; und (iii) diesen Vertrag zu kündigen.
              </p>
            </li>

            <li>
              <p>
                <b> Links. </b>
                <br />
                Die Plattform kann Links zu anderen Internetseiten und Ressourcen enthalten, und der
                Nutzer erkennt hiermit an und stimmt zu, dass: (i) QuillBot nicht für die
                Verfügbarkeit solcher externen Websites oder Ressourcen verantwortlich ist; und (ii)
                QuillBot nicht für Inhalte, Werbung, Produkte oder andere Materialien auf oder von
                solchen Websites oder Ressourcen verantwortlich oder haftbar ist. Der Nutzer erklärt
                sich damit einverstanden, dass QuillBot weder direkt noch indirekt für Schäden oder
                Verluste verantwortlich oder haftbar ist, die durch oder in Verbindung mit der
                Nutzung von oder dem Vertrauen auf solche Inhalte, Waren oder Dienstleistungen, die
                auf oder über solche Websites oder Ressourcen verfügbar sind, verursacht wurden oder
                angeblich verursacht wurden.
              </p>
            </li>

            <li>
              <p>
                <b> Beschränkte Haftung.</b>
              </p>

              <ol type="a">
                <li>
                  <p>
                    QUILLBOT, SEINE VERBUNDENEN UNTERNEHMEN, TOCHTERGESELLSCHAFTEN, LEITENDEN
                    ANGESTELLTEN, DIREKTOREN, MITARBEITER, VERTRETER, LIZENZGEBER, NACHFOLGER ODER
                    RECHTSNACHFOLGER (“QUILLBOT- PARTEIEN“) HAFTEN NICHT FÜR DIREKTE, INDIREKTE,
                    ZUFÄLLIGE, BESONDERE ODER FOLGESCHÄDEN, DIE SICH AUS ODER IM ZUSAMMENHANG MIT
                    (I) DER VERFÜGBARKEIT DER PLATTFORM; (II) DEN HANDLUNGEN, UNTERLASSUNGEN ODER
                    DEM VERHALTEN EINES NUTZERS ODER EINES DRITTEN, OB ONLINE ODER OFFLINE; (III)
                    JEGLICHEN INHALTEN DER PLATTFORM; (IV) JEGLICHEN WAREN ODER DIENSTLEISTUNGEN,
                    DIE ALS ERGEBNIS VON ÜBER DIE PLATTFORM ERHALTENEN INFORMATIONEN ODER
                    ABGESCHLOSSENEN TRANSAKTIONEN ERWORBEN WURDEN; ODER (V) JEGLICHER NUTZUNG VON
                    WAREN ODER DIENSTLEISTUNGEN, DIE AUF EINER MIT DER PLATTFORM VERLINKTEN
                    INTERNETRESSOURCE ODER WEBSEITE ZUR VERFÜGUNG GESTELLT WERDEN. DIE
                    QUILLBOT-PARTEIEN HAFTEN NICHT FÜR TECHNISCHE STÖRUNGEN VON TELEFONANLAGEN,
                    MOBILFUNKNETZEN, KABELSYSTEMEN, COMPUTERAUSRÜSTUNGEN, SERVERN, ANBIETERN ODER
                    SOFTWARE. DIE QUILLBOT-PARTEIEN HAFTEN NICHT FÜR VERLETZUNGEN ODER SCHÄDEN AM
                    COMPUTER ODER AN DER AUSRÜSTUNG DES NUTZERS, DIE SICH AUS DEM ZUGANG ZUR ODER
                    DER NUTZUNG DER PLATTFORM ERGEBEN, EINSCHLIESSLICH, ABER NICHT BESCHRÄNKT AUF
                    DAS BETRACHTEN VON WEBSEITEN, DAS HERUNTERLADEN ODER STREAMEN VON DATEIEN, DIE
                    NUTZUNG ODER DEN ZUGANG ZUM SERVER ODER DAS FOLGEN VON PLATTFORM-LINKS. DER
                    NUTZER GREIFT AUF EIGENES RISIKO AUF DIE PLATTFORM ZU UND IST ALLEIN
                    VERANTWORTLICH FÜR JEGLICHE VERLUSTE, SCHÄDEN ODER KOSTEN, DIE DURCH SOLCHE
                    AKTIVITÄTEN ENTSTEHEN. DIE QUILLBOT-PARTEIEN ÜBERNEHMEN KEINE VERANTWORTUNG FÜR
                    FEHLERHAFTE ODER UNGENAUE INHALTE, DIE AUF DER PLATTFORM VERÖFFENTLICHT ODER VON
                    DER PLATTFORM EMPFANGEN WERDEN, UNABHÄNGIG VON DER URSACHE FÜR DIESE
                    UNGENAUIGKEIT. DIE QUILLBOT-PARTEIEN SIND NICHT VERANTWORTLICH FÜR DAS VERHALTEN
                    EINES NUTZERS DER PLATTFORM. DIE QUILLBOT-PARTEIEN SIND NICHT VERANTWORTLICH FÜR
                    FEHLER, AUSLASSUNGEN, UNTERBRECHUNGEN, LÖSCHUNGEN, DEFEKTE,
                    BETRIEBSVERZÖGERUNGEN, AUSFÄLLE DER KOMMUNIKATIONSLEITUNGEN ODER DIEBSTAHL,
                    VERLETZUNG, ZERSTÖRUNG ODER VERÄNDERUNG DER KOMMUNIKATION DES NUTZERS. KEINE
                    DATEN ODER INFORMATIONEN, DIE VON DEN QUILLBOT-PARTEIEN ERHALTEN WERDEN,
                    BEGRÜNDEN IRGENDEINE GARANTIE.
                  </p>
                </li>

                <li>
                  <p>
                    DIE GESAMTE HAFTUNG DER QUILLBOT-PARTEIEN GEGENÜBER DEM NUTZER ODER EINEM
                    DRITTEN, DIE SICH AUS DER PLATTFORM ODER DER VEREINBARUNG ERGIBT ODER DAMIT IN
                    ZUSAMMENHANG STEHT, ÜBERSTEIGT NICHT DEN BETRAG VON ZEHN DOLLAR ($10.00).
                  </p>
                </li>

                <li>
                  <p>
                    DER ZUGRIFF DES NUTZERS AUF ODER DIE NUTZUNG VON INTERNETRESSOURCEN DRITTER, DIE
                    MIT DER SOFTWARE VERLINKT SIND, ODER DIE NUTZUNG VON GÜTERN ODER
                    DIENSTLEISTUNGEN AUS INTERNETRESSOURCEN DRITTER, DIE MIT DER SOFTWARE VERLINKT
                    SIND, ERFOLGT AUF EIGENES RISIKO DES NUTZERS. DER NUTZER STELLT HIERMIT DIE
                    QUILLBOT-PARTEIEN VON JEGLICHEN SCHÄDEN FREI, DIE DEM NUTZER DURCH DEN ZUGRIFF
                    AUF INTERNETRESSOURCEN DRITTER ENTSTEHEN, UND DER NUTZER ERKLÄRT SICH DAMIT
                    EINVERSTANDEN, KEINE ANSPRÜCHE GEGEN DIE QUILLBOT- PARTEIEN GELTEND ZU MACHEN,
                    DIE SICH AUS DEM ERWERB VON WAREN UND DIENSTLEISTUNGEN ERGEBEN, DIE ÜBER DIE
                    PLATTFORM ODER ÜBER INTERNETRESSOURCEN DRITTER VERFÜGBAR GEMACHT WERDEN.
                  </p>
                </li>

                <li>
                  <p>
                    DIE QUILLBOT-PARTEIEN HAFTEN NICHT FÜR SCHÄDEN, DIE SICH AUS DEM VERSÄUMNIS
                    EINER PARTEI ERGEBEN, PASSWÖRTER ODER KONTOINFORMATIONEN DER NUTZER ZU SCHÜTZEN.
                    DIE QUILLBOT-PARTEIEN HAFTEN NICHT FÜR AUSFÄLLE ODER VERZÖGERUNGEN IM RAHMEN DES
                    VERTRAGS, DIE AUF UMSTÄNDE ZURÜCKZUFÜHREN SIND, DIE AUSSERHALB DER KONTROLLE DER
                    QUILLBOT-PARTEIEN LIEGEN, EINSCHLIESSLICH, ABER NICHT BESCHRÄNKT AUF
                    NATURKATASTROPHEN, BEHÖRDLICHE HANDLUNGEN, GESETZE ODER VERORDNUNGEN,
                    TERRORISMUS, STREIKS ODER ARBEITSSCHWIERIGKEITEN, UNTERBRECHUNGEN DES
                    KOMMUNIKATIONSSYSTEMS, HARDWARE- ODER SOFTWAREAUSFÄLLE, TRANSPORTUNTERBRECHUNGEN
                    ODER DIE UNFÄHIGKEIT, MATERIAL ODER LIEFERUNGEN ZU BESCHAFFEN. DIE
                    QUILLBOT-PARTEIEN HAFTEN NICHT FÜR ILLEGALE, MISSBRÄUCHLICHE ODER ANDERWEITIG
                    UNANGEMESSENE AKTIVITÄTEN DES NUTZERS, EINSCHLIESSLICH, ABER NICHT BESCHRÄNKT
                    AUF DIE VERWENDUNG DER PLATTFORM ZUR VERLETZUNG DES URHEBERRECHTS ODER ANDERER
                    GEISTIGER EIGENTUMSRECHTE ANDERER. DIE QUILLBOT-PARTEIEN HAFTEN NICHT FÜR DIE
                    EINHALTUNG ODER DAS FEHLEN EINER EINHALTUNG DER GELTENDEN GESETZE UND
                    VERORDNUNGEN DURCH DRITTANBIETER.
                  </p>
                </li>
              </ol>
            </li>

            <li>
              <p>
                <b> Entschädigung. </b>
              </p>
              <ol type="a">
                <li>
                  <p>
                    <b>Vorkommnis.</b>
                    <br />
                    Der Nutzer erklärt sich damit einverstanden, die QuillBot-Parteien im vollen
                    gesetzlich zulässigen Umfang gegen alle Ansprüche, Forderungen und/oder Klagen
                    zu verteidigen und die QuillBot-Parteien von allen Verlusten, Schäden, Kosten
                    und Ausgaben, einschließlich angemessener Anwaltsgebühren, (jeweils ein
                    „Anspruch“) freizustellen und schadlos zu halten, unabhängig davon, ob ein
                    solcher Anspruch auf aktive oder passive Fahrlässigkeit einer QuillBot- Partei
                    zurückzuführen ist, die sich aus oder im Zusammenhang mit einem solchen Anspruch
                    ergeben: (i) einem Verstoß des Nutzers gegen eine Bestimmung dieser Vereinbarung
                    und/oder eine hierin enthaltene Zusicherung oder Gewährleistung; (ii) der
                    Nutzung der Plattform durch den Nutzer, einschließlich der vom Nutzer
                    übermittelten oder empfangenen Daten oder Informationen; (iii) einer
                    inakzeptablen Nutzung der Plattform durch den Nutzer, einschließlich, aber nicht
                    beschränkt auf Aussagen, Daten oder Inhalte, die vom Nutzer gemacht, übertragen
                    oder neu veröffentlicht wurden und die eine Rechtsverletzung darstellen oder
                    anderweitig als inakzeptabel in Abschnitt 6 verboten sind; oder (iv) allen
                    Ausgaben, die QuillBot bei der Durchsetzung dieses Abschnitts entstehen,
                    einschließlich, aber nicht beschränkt auf angemessene Anwaltsgebühren und
                    -kosten.
                  </p>
                </li>

                <li>
                  <p>
                    <b>Verfahren. </b>
                    <br />
                    QuillBot benachrichtigt den Nutzer unverzüglich über jeden Anspruch oder jede
                    Klage in Bezug auf einen Anspruch auf Entschädigung im Rahmen dieser
                    Vereinbarung, und der Nutzer übernimmt die Verteidigung oder Beilegung und alle
                    damit verbundenen Kosten und Ausgaben für jeden Anspruch oder jede Klage, für
                    die er eine Entschädigungspflicht hat. Der Nutzer hat das Recht, jede Klage, auf
                    die seine Entschädigung anwendbar ist, beizulegen oder einen Vergleich zu
                    schließen, außer dass der Nutzer ohne die vorherige schriftliche Zustimmung von
                    QuillBot keinem Vergleich zustimmen darf, wenn ein solcher Vergleich dazu führen
                    würde, dass QuillBot eine Handlung vornimmt, eine Haftung übernimmt, Gelder
                    zahlt, ein Fehlverhalten anerkennt oder ein Urteil gegen sich ergehen lässt.
                    Ungeachtet des Vorstehenden hat QuillBot das Recht, die Verteidigung eines gegen
                    ihn geltend gemachten Anspruchs auf Kosten des Nutzers zu übernehmen, falls: (i)
                    der Nutzer es versäumt, die Verteidigung eines solchen Anspruchs zu übernehmen;
                    (ii) QuillBot vernünftigerweise feststellt, dass ein nachteiliger Ausgang
                    wesentlich für das Geschäft von QuillBot sein könnte; (iii) es Konflikte
                    zwischen den Interessen des Nutzers und denen von QuillBot in einem solchen
                    Rechtsstreit gibt; oder (iv) QuillBot vernünftigerweise glaubt, dass der Nutzer
                    nicht über die notwendigen finanziellen Mittel verfügt, um seine
                    Entschädigungsverpflichtung im Falle eines nachteiligen Ausgangs zu erfüllen.
                  </p>
                </li>
              </ol>
            </li>
            <li>
              <p>
                <b>QuillBot Datenschutzrichtlinie. </b>
                <br />
                Der Nutzer erkennt an, dass er die Datenschutzrichtlinie von QuillBot gelesen hat,
                die unter
                <a href="https://quillbot.com/privacy"> https://quillbot.com/privacy</a> verfügbar
                ist.
              </p>
            </li>

            <li>
              <p>
                <b>Aufforderungen zur Entfernung von Inhalten, DMCA.</b>
                <br />
                QuillBot verbietet es Nutzern ausdrücklich, Inhalte hochzuladen, zu posten oder
                anderweitig über die Plattform zu verbreiten, die die geistigen Eigentumsrechte, die
                Privatsphäre, die Öffentlichkeit oder andere Rechte einer anderen Partei verletzen
                könnten. Wenn ein Nutzer der Meinung ist, dass ein Inhalt auf der Plattform die
                Rechte eines Nutzers verletzt oder anderweitig gegen diese Rechte verstößt, wird der
                Nutzer aufgefordert, QuillBot unverzüglich zu kontaktieren und zu verlangen, dass
                der vermeintlich verletzende Inhalt (“verletzender Inhalt“) von der Plattform
                entfernt wird. Um einen solchen Antrag (“Take-Down Request“) zu stellen, sollte der
                Nutzer den unten aufgeführten Beauftragten von QuillBot wie folgt informieren:
              </p>
              <ol type="a">
                <li>
                  <p>
                    die Identität des verletzenden Inhalts so genau angeben, dass er leicht gefunden
                    werden kann (z. B. “Das Foto von https://quillbot.com/item123.jpg”);
                  </p>
                </li>
                <li>
                  <p>Name, Postanschrift, E-Mail-Adresse und Telefonnummer des Nutzers; und </p>
                </li>

                <li>
                  <p>
                    den Namen, die Nutzer-ID, die E-Mail-Adresse, die Telefonnummer und die
                    Postanschrift der Person, von der der Nutzer annimmt, dass sie den beleidigenden
                    Inhalt veröffentlicht hat (sofern verfügbar).
                  </p>

                  <p>
                    n Übereinstimmung mit dem Digital Millennium Copyright Act („DMCA“) hat QuillBot
                    einen Urheberrechtsbeauftragten benannt, der mit der Entgegennahme von
                    Benachrichtigungen über angebliche Urheberrechtsverletzungen beauftragt ist und
                    Benachrichtigungen über andere verletzende Plattforminhalte annehmen kann. Wenn
                    der Nutzer in gutem Glauben davon ausgeht, dass auf dieser Website erscheinendes
                    Material sein Urheberrecht verletzt, muss er dies gemäß 17 U.S.C. § 512(c)(3)(A)
                    unserem Urheberrechtsbeauftragten unter folgender Adresse mitteilen:
                  </p>

                  <p>
                    Rohan Gupta <br />
                    1105 Midwest
                    <br /> Club Oak Brook, <br />
                    IL 60523 <br />
                    dmca@quillbot.com <br /> +1 (856) 485-8297
                  </p>

                  <p>
                    In ähnlicher Weise sieht der DMCA vor, dass ein Nutzer, der in gutem Glauben
                    davon ausgeht, dass eine Mitteilung über eine Urheberrechtsverletzung zu Unrecht
                    gegen ihn eingereicht wurde, eine Gegenmitteilung an unseren
                    Urheberrechtsbeauftragten senden kann, vorbehaltlich der in 17 U.S.C. §
                    512(g)(3) dargelegten Anforderungen.
                  </p>

                  <p>
                    Schließlich ist darauf hinzuweisen, dass Personen, die bei der Behauptung, dass
                    auf dieser Website erscheinendes Material eine Urheberrechtsverletzung
                    darstellt, falsche Angaben machen, gemäß 17 U.S.C. § 512(f)
                    schadenersatzpflichtig sein können. QuillBot bearbeitet ordnungsgemäße
                    Take-Down-Anträge, entfernt oder sperrt den Zugang zu anstößigen oder
                    verletzenden Inhalten unverzüglich und kündigt die Konten von
                    Wiederholungstätern.
                  </p>
                </li>
              </ol>
            </li>

            <li>
              <p>
                <b> Protokoll zur Beilegung von Streitigkeiten.</b>
              </p>

              <ol type="a">
                <li>
                  <p>
                    <b>Geltendes Recht und Gerichtsstand.. </b>
                    <br />
                    Diese Vereinbarung wird in Übereinstimmung mit den Gesetzen des Staates Illinois
                    und der Vereinigten Staaten von Amerika ausgelegt, ohne Rücksicht auf die
                    Bestimmungen des Kollisionsrechts. Der Nutzer und QuillBot erklären sich damit
                    einverstanden, sich der persönlichen Gerichtsbarkeit der Staats- und
                    Bundesgerichte im Cook County, Illinois, zu unterwerfen, wenn es um tatsächliche
                    oder drohende Verstöße gegen Urheberrechte, Marken, Geschäftsgeheimnisse,
                    Patente oder andere geistige Eigentumsrechte einer Partei oder um die
                    ausstehende Zahlung der hierunter fälligen Gebühren durch den Nutzer geht.
                  </p>
                </li>

                <li>
                  <p>
                    <b>Verhandlungen.</b>
                    <br />
                    Für den Fall, dass ein Streitfall entsteht, mit Ausnahme von Streitfällen, die
                    eine tatsächliche oder drohende Verletzung, Unterschlagung oder Verletzung der
                    Rechte an geistigem Eigentum einer Partei betreffen, vereinbaren der Nutzer und
                    QuillBot, zunächst zu versuchen, die Lösung eines Streitfalls informell für
                    mindestens dreißig (30) Tage auszuhandeln, bevor ein Schiedsgerichts- oder
                    Gerichtsverfahren eingeleitet wird.
                  </p>
                </li>

                <li>
                  <p>
                    <b> Andere Parteien.</b>
                    <br />
                    Der Nutzer akzeptiert, dass QuillBot als Unternehmen ein Interesse daran hat,
                    die persönliche Haftung seiner leitenden Angestellten und Mitarbeiter zu
                    begrenzen. Der Nutzer stimmt zu, dass er keine persönlichen Ansprüche gegen die
                    leitenden Angestellten oder Mitarbeiter von QuillBot in Bezug auf Verluste, die
                    der Nutzer in Verbindung mit der Plattform erleidet, geltend machen wird.
                    Unbeschadet des Vorstehenden erklärt sich der Nutzer damit einverstanden, dass
                    die in dieser Vereinbarung festgelegten Beschränkungen der Garantien und der
                    Haftung sowohl die leitenden Angestellten, Mitarbeiter, Vertreter,
                    Tochtergesellschaften, Nachfolger, Abtretungsempfänger und Unterauftragnehmer
                    von QuillBot als auch QuillBot schützen werden.
                  </p>
                </li>

                <li>
                  <p>
                    <b>Verbindliche Schlichtung. </b>
                    <br />
                    Alle Ansprüche, die sich aus der Nutzung der Plattform ergeben (mit Ausnahme von
                    Streitigkeiten, die eine tatsächliche oder drohende Verletzung, widerrechtliche
                    Aneignung oder Verletzung der Urheberrechte, Marken, Geschäftsgeheimnisse,
                    Patente oder anderer geistiger Eigentumsrechte einer Partei oder die ausstehende
                    Zahlung fälliger Gebühren durch den Nutzer betreffen), werden endgültig und
                    ausschließlich durch ein verbindliches Schiedsverfahren gelöst. Jede
                    Entscheidung für ein Schiedsverfahren durch eine der Parteien ist endgültig und
                    bindend für die andere Partei. Der Nutzer nimmt zur Kenntnis, dass keine der
                    Parteien das Recht hat, vor Gericht zu klagen oder ein Schwurgerichtsverfahren
                    zu führen, wenn sich eine der Parteien für ein Schiedsverfahren entscheidet. Das
                    Schiedsverfahren wird nach den Commercial Arbitration Rules der American
                    Arbitration Association („AAA“) und gegebenenfalls nach den Supplementary
                    Procedures for Consumer Related Disputes der AAA eingeleitet und durchgeführt,
                    die beide auf der AAA-Website{' '}
                    <a href="http://www.adr.org">http://www.adr.org</a> verfügbar sind. Die Parteien
                    reichen Schriftsätze von höchstens 10 Seiten ein, und die schiedsrichterliche
                    Anhörung wird auf maximal zwei (2) Tage begrenzt. Der Schiedsrichter muss das
                    Recht von Illinois anwenden, und jeder Schiedsspruch kann angefochten werden,
                    wenn der Schiedsrichter dies nicht tut. Sofern von den Parteien nicht anders
                    vereinbart, findet das Schiedsverfahren in Chicago, Illinois, statt. Die
                    Schiedsgerichtsgebühren und der Anteil des Nutzers an der Entschädigung des
                    Schiedsrichters werden durch die AAA-Regeln geregelt und gegebenenfalls durch
                    die AAA-Verbraucherregeln begrenzt. Wenn der Schadensersatzanspruch des Nutzers
                    10.000 $ nicht übersteigt, zahlt QuillBot den Anteil des Nutzers an den
                    Schiedsgerichtsgebühren, es sei denn, der Schiedsrichter stellt fest, dass
                    entweder der Inhalt des Anspruchs des Nutzers oder die angestrebte Entschädigung
                    leichtfertig war oder zu einem unzulässigen Zweck gemäß Federal Rule of Civil
                    Procedure 11(b) vorgebracht wurde. Das Schiedsverfahren kann persönlich, durch
                    Einreichung von Dokumenten, per Telefon oder online durchgeführt werden. Die
                    Entscheidung des Schiedsrichters ergeht in schriftlicher Form. Die Parteien
                    können vor Gericht klagen, um ein Schiedsverfahren zu erzwingen, das Verfahren
                    bis zum Abschluss des Schiedsverfahrens auszusetzen oder den Schiedsspruch des
                    Schiedsrichters zu bestätigen, zu ändern, aufzuheben oder zu bestätigen.
                  </p>
                </li>

                <li>
                  <p>
                    <b>VERZICHT AUF DAS RECHT, KLÄGER ODER MITGLIED EINER GRUPPE ZU SEIN..</b>
                    <br />
                    DER NUTZER UND QUILLBOT VEREINBAREN, DASS JEDES SCHIEDSVERFAHREN AUF DEN
                    STREITFALL ZWISCHEN QUILLBOT UND DEM NUTZER INDIVIDUELL BESCHRÄNKT IST. DER
                    NUTZER ERKENNT AN UND STIMMT ZU, DASS DER NUTZER UND QUILLBOT JEWEILS AUF DAS
                    RECHT VERZICHTEN, ALS KLÄGER ODER SAMMELMITGLIED AN EINER ANGEBLICHEN
                    SAMMELKLAGE ODER EINEM REPRÄSENTATIVEN VERFAHREN TEILZUNEHMEN. DER
                    SCHIEDSRICHTER DARF NICHT MEHR ALS EINEN ANSPRUCH DES NUTZERS ZUSAMMENFASSEN UND
                    DARF AUCH SONST NICHT DEN VORSITZ IN IRGENDEINER FORM EINES GRUPPEN- ODER
                    REPRÄSENTATIVEN VERFAHRENS ÜBERNEHMEN.
                  </p>
                </li>
              </ol>
            </li>

            <li>
              <p>
                <b> Gemischtes.</b>
              </p>
              <ol type="a">
                <li>
                  <p>
                    <b>Verzicht; kumulative Rechtsmittel. </b>
                    <br />
                    Soweit dies nach geltendem Recht zulässig ist: (i) kann keine Forderung oder
                    kein Recht, die bzw. das sich aus diesem Abkommen oder einem der Dokumente, auf
                    die in diesem Abkommen Bezug genommen wird, ergibt, von einer Vertragspartei
                    ganz oder teilweise durch einen Verzicht auf die Forderung oder das Recht
                    abgegolten werden, es sei denn, es liegt eine schriftliche, von der betreffenden
                    Vertragspartei unterzeichnete Erklärung vor; (ii) eine Verzichtserklärung einer
                    Vertragspartei gilt nur für den speziellen Fall, für den sie abgegeben wurde;
                    und (iii) keine Mitteilung an eine Vertragspartei oder Aufforderung an eine
                    Vertragspartei gilt als Verzicht auf eine Verpflichtung dieser Vertragspartei
                    oder auf das Recht der die Mitteilung oder Aufforderung abgebenden
                    Vertragspartei, weitere Maßnahmen ohne Mitteilung oder Aufforderung gemäß diesem
                    Abkommen zu ergreifen.
                  </p>
                </li>

                <li>
                  <p>
                    <b>Vollständige Vereinbarung und Änderung. </b>
                    <br />
                    Diese Vereinbarung stellt die vollständige und ausschließliche Erklärung der
                    Vereinbarung zwischen den Parteien in Bezug auf die Plattform dar und ersetzt
                    alle früheren oder gleichzeitigen Mitteilungen, Darstellungen, Erklärungen und
                    Absprachen, ob mündlich oder schriftlich, zwischen den Parteien in Bezug auf die
                    Plattform. Diese Vereinbarung kann von QuillBot und dem Nutzer in schriftlicher
                    Form geändert werden.
                  </p>
                </li>

                <li>
                  <p>
                    <b>Trennbarkeit. </b>
                    <br />
                    Sollte eine Bestimmung dieser Vereinbarung von einem zuständigen Gericht für
                    ungültig oder nicht durchsetzbar erklärt werden, bleiben die anderen
                    Bestimmungen dieser Vereinbarung in vollem Umfang in Kraft und wirksam. Jede
                    Bestimmung dieser Vereinbarung, die nur teilweise oder in einem gewissen Umfang
                    für ungültig oder nicht durchsetzbar gehalten wird, bleibt in dem Umfang, in dem
                    sie nicht für ungültig oder nicht durchsetzbar gehalten wird, in vollem Umfang
                    gültig und wirksam.
                  </p>
                </li>

                <li>
                  <p>
                    <b>Rechtsmittel. </b>
                    <br />
                    Die von QuillBot hierin gewährten Rechte sind von besonderer, einzigartiger und
                    intellektueller Natur, was ihnen einen besonderen Wert verleiht, dessen Verlust
                    nicht vernünftig oder angemessen durch Schadenersatz in einem Rechtsstreit
                    kompensiert werden kann. Darüber hinaus erkennt der Nutzer an, dass der Nutzer
                    während des Zugriffs auf die Plattform oder der Nutzung der Plattform Zugang zu
                    den geschützten Informationen von QuillBot haben wird oder haben kann,
                    einschließlich und nicht beschränkt auf den Code der Plattform und zugehörige
                    Materialien. Dementsprechend wird die Verletzung der Bestimmungen dieser
                    Vereinbarung bezüglich der Eigentumsrechte von QuillBot durch den Nutzer
                    QuillBot irreparable Verletzungen und Schäden zufügen, für die QuillBot
                    berechtigt ist, ohne eine Kaution oder Sicherheit zu hinterlegen, eine
                    Unterlassungsklage oder einen anderen angemessenen Rechtsbehelf zu beantragen.
                    Die Gewährung von Rechtsmitteln nach dem Billigkeitsrecht ist nicht als Verzicht
                    auf andere Rechte von QuillBot nach dem Gesetz oder nach dem Billigkeitsrecht
                    auszulegen. Der Nutzer erklärt sich damit einverstanden, dass die Rechte und
                    Rechtsmittel des Nutzers im Falle eines Verstoßes gegen diesen Vertrag durch
                    QuillBot auf das Recht beschränkt sind, gegebenenfalls Schadensersatz in einem
                    Rechtsstreit zu erlangen, und dass der Nutzer in keinem Fall berechtigt ist,
                    diesen Vertrag zu kündigen oder zu widerrufen oder QuillBot die Nutzung oder
                    Verwertung der Einsendungen zu untersagen oder einzuschränken.
                  </p>
                </li>

                <li>
                  <p>
                    <b>Abtretung. </b>
                    <br />
                    QuillBot kann jederzeit und ohne Zustimmung des Nutzers seine Rechte abtreten
                    oder seine Verpflichtungen an eine andere Person oder Einrichtung übertragen.
                    Der Nutzer darf ohne die vorherige schriftliche Zustimmung von QuillBot keine
                    seiner Rechte abtreten oder seine Verpflichtungen an eine andere natürliche oder
                    juristische Person übertragen. Vorbehaltlich des vorstehenden Satzes gilt dieser
                    Vertrag für die Rechtsnachfolger und zulässigen Abtretungsempfänger der
                    Parteien, ist für diese in jeder Hinsicht verbindlich und kommt ihnen zugute.
                    Nichts, was in dieser Vereinbarung ausgedrückt oder erwähnt wird, ist so
                    auszulegen, dass es einer anderen Person als den Parteien dieser Vereinbarung
                    ein rechtliches oder billiges Recht, einen Rechtsbehelf oder einen Anspruch
                    unter oder in Bezug auf diese Vereinbarung oder eine Bestimmung dieser
                    Vereinbarung gibt, mit Ausnahme der Rechte, die einem Nachfolger oder zulässigen
                    Abtretungsempfänger gemäß diesem Abschnitt zustehen.
                  </p>
                </li>

                <li>
                  <p>
                    <b>Kalifornische Verbraucherbeschwerden.</b>
                    <br />
                    Gemäß der Cal. Civ. Code. § 1789.3 können Verbraucherbeschwerden oder Anfragen
                    nach weiteren Informationen an info@quillbot.com gesendet werden. Die
                    Beschwerdestelle der Abteilung für Verbraucherdienste des Kalifornischen
                    Verbraucherministeriums (Department of Consumer Affairs, DCA)ist unter folgender
                    Adresse zu erreichen: 1625 North Market Blvd., Suite N 112 Sacramento, CA 95834
                    (800) 952-5210.
                  </p>
                </li>

                <li>
                  <p>
                    <b>Fortbestehen. </b>
                    <br />
                    Die Abschnitte 3, 5-6, 10-11 und 14-15 gelten auch nach Beendigung dieser
                    Vereinbarung.
                  </p>
                </li>
              </ol>
            </li>

            <li>
              <p>
                <b>Quelloffene Software.</b>
                <br />
                Die Plattform nutzt die folgenden Open-Source-Komponenten, deren Quellcode unter den
                nebenstehenden URLs heruntergeladen werden kann:
              </p>
              <ol type="a">
                <li>
                  <p>JQuery (https://jquery.com/)</p>
                </li>
                <li>
                  <p> NodeJS (https://nodejs.org/)</p>
                </li>
                <li>
                  <p>Express (https://expressjs.com/)</p>
                </li>
                <li>
                  <p> Flask (http://flask.pocoo.org/)</p>
                </li>
                <li>
                  <p>React (https://reactjs.org/)</p>
                </li>
                <li>
                  <p> CreateJS (https://createjs.com/)</p>
                </li>
                <li>
                  <p>D3js (https://d3js.org/)</p>
                </li>
                <li>
                  <p>Flaticon for images (https://www.flaticon.com/)</p>
                </li>
                <li>
                  <p>
                    Highlight within textarea
                    (https://github.com/lonekorean/highlight-within-textarea)
                  </p>
                </li>
                <li>
                  <p> Pytorch (https://pytorch.org/)</p>
                </li>
                <li>
                  <p> NextJs (https://nextjs.org/)</p>
                </li>
                <li>
                  <p> NestJs (https://nestjs.com/)</p>
                </li>
              </ol>
            </li>
          </ol>
          <p> Terms of Service © 2022 QuillBot (Course Hero), LLC</p>
        </div>
      </div>
    </div>
  );
}

export default TermsPageDE;
